import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ControlledTooltip from '../ControlledTooltip/ControlledTooltip';

const Tooltip = ({
  classNames,
  content,
  children,
  preferredPosition = 'top',
  preventTabbing = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = (event) => {
    if (preventTabbing && event.nativeEvent.pointerType === 'touch') {
      return;
    }
    setIsOpen(true);
  };
  const close = () => setIsOpen(false);

  return (
    <ControlledTooltip
      classNames={classNames}
      delayed
      content={content}
      preferredPosition={preferredPosition}
      isOpen={isOpen}
      onPointerEnter={open}
      onFocus={open}
      onPointerLeave={close}
      onBlur={close}
    >
      {children}
    </ControlledTooltip>
  );
};

Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = {
  /** Optional array of CSS utility classes. */
  classNames: PropTypes.arrayOf(PropTypes.string),
  /** The content of the tooltip. We support text content and the <strong>-Tag */
  content: PropTypes.node.isRequired,
  /** Content to wrap which then will respond on mouse over with the tooltip. */
  children: PropTypes.node.isRequired,
  /** The preferred position of the tooltip when there is enough space. */
  preferredPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  preventTabbing: PropTypes.bool,
};

export default Tooltip;
